import React from 'react';
import PropTypes from 'prop-types';

import {DatePicker} from '@mui/x-date-pickers';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {AdapterMoment} from '@mui/x-date-pickers/AdapterMoment';

const DatePickerYearMonth = (props) => {
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DatePicker
        {...props}
        views={['year', 'month']}
        slotProps={{
          textField: {
            ...props.textFieldProps,
          },
        }}
      />
    </LocalizationProvider>
  );
};

DatePickerYearMonth.propTypes = {
  locale: PropTypes.string,
  textFieldProps: PropTypes.object,
};

export default React.memo(DatePickerYearMonth);
